import {useState} from "react";
import AuthenticationService from "../services/api/authentication";

const useAuthentication = () => {

    const [isFetchingTotalAuthentication, setFetchingTotalAuthentication] = useState(false);
    const [isFetchingAuthenticationStatus, setFetchingAuthenticationStatus] = useState(false);
    const [isFetchingAuthenticationFailRate, setFetchingAuthenticationFailRate] = useState(false);
    const [isFetchingAuthenticationDocumentList, setFetchingAuthenticationDocumentList] = useState(false);
    const [isFetchingAuthenticationCount, setFetchingAuthenticationCount] = useState(false);
    const [isFetchingAuthenticationProductList, setFetchingAuthenticationProductList] = useState(false);
    const [totalAuthenticationCount, setTotalAuthenticationCount] = useState(0);
    const [totalAuthenticationStatus, setTotalAuthenticationStatus] = useState(0);
    const [authenticationFailRateData, setAuthenticationFailRateData] = useState([]);
    const [authenticationDateTypeCount, setAuthenticationDateTypeCount] = useState([]);
    const [authenticationDocumentList, setAuthenticationDocumentList] = useState([]);
    const [authenticationProductList, setAuthenticationProductList] = useState([]);
    const [pagination, setPagination] = useState(0);
    const [isViewDocument, setViewDocument] = useState(false);
    const [isViewProduct, setViewProduct] = useState(false);
    const [documentViewDetails, setDocumentViewDetails] = useState(null);
    const [productViewDetails, setProductViewDetails] = useState(null);

    const [isSearchingProductByType, setSearchingProductByType] = useState(false);
    const [searchedProductTypeResult, setSearchedProductTypeResult] = useState([]);


    const limit = 10;

    
    const getAuthenticationCount = (startDate, endDate) => {
        setFetchingTotalAuthentication(true);

        AuthenticationService.getAuthenticationCount(startDate, endDate).then((res) => {
            
            if (res.data.success) {
                setFetchingTotalAuthentication(false);
                setTotalAuthenticationCount(res.data.data);
            }

        }).catch((error) => {
            console.log("getAuthenticationCount error xxxx", error);

            setFetchingTotalAuthentication(false);
        })
    }
    

    const getAuthenticationStatus = (startDate, endDate) => {
        setFetchingAuthenticationStatus(true);

        AuthenticationService.getAuthenticationStatus(startDate, endDate).then((res) => {
            
            if (res.data.success) {
                setFetchingAuthenticationStatus(false);
                setTotalAuthenticationStatus(res.data.data);
            }

        }).catch((error) => {
            console.log("getAuthenticationStatus error xxxx", error);

            setFetchingAuthenticationStatus(false);
        })
    }


    const getAuthenticationFailRate = (startDate, endDate) => {
        setFetchingAuthenticationFailRate(true);

        AuthenticationService.getAuthenticationFailRate(startDate, endDate).then((res) => {
            
            if (res.data.success) {
                setFetchingAuthenticationFailRate(false);
                setAuthenticationFailRateData(res.data.data);
            }

        }).catch((error) => {
            console.log("getAuthenticationFailRate error xxxx", error);

            setFetchingAuthenticationFailRate(false);
        })
    }


    const getAuthenticationDateTypeCount = (startDate, endDate) => {
        setFetchingAuthenticationCount(true);

        AuthenticationService.getAuthenticationDateTypeCount(startDate, endDate).then((res) => {
            console.log("getAuthenticationDateTypeCount res bbbb", res )
            
            if (res.data.success) {
                setFetchingAuthenticationCount(false);
                setAuthenticationDateTypeCount(res.data.data);
            }

        }).catch((error) => {
            console.log("getAuthenticationDateTypeCount error xxxx", error);

            setFetchingAuthenticationCount(false);
        })
    }



    const getAuthenticationDocumentList = (page) => {
        setFetchingAuthenticationDocumentList(true);

        AuthenticationService.getAuthenticationDocumentList(page, limit).then((res) => {
            
            if (res.data.success) {
                
                setFetchingAuthenticationDocumentList(false);
                setAuthenticationDocumentList(res.data.data.content);

                if (res.data.data.length === 0) {
                    setPagination(0);
                } else {
                    var last_page = Math.ceil(res.data.data.numberOfElements / limit); 
                    setPagination(last_page);
                }
            }

        }).catch((error) => {
            console.log("getAuthenticationDocumentList error xxxx", error);

            setFetchingAuthenticationDocumentList(false);
        })
    }


    const getAuthenticationDocumentListByType = (page, type) => {
        setFetchingAuthenticationDocumentList(true);

        AuthenticationService.getAuthenticationDocumentListByType(page, limit, type).then((res) => {
            
            if (res.data.success) {
                
                setFetchingAuthenticationDocumentList(false);
                setAuthenticationDocumentList(res.data.data.content);

                if (res.data.data.length === 0) {
                    setPagination(0);
                } else {
                    var last_page = Math.ceil(res.data.data.numberOfElements / limit); 
                    setPagination(last_page);
                }
            }

        }).catch((error) => {
            console.log("getAuthenticationDocumentListByType error xxxx", error);

            setFetchingAuthenticationDocumentList(false);
        })
    }

    const getAuthenticationDocumentListByStatus = (page, status) => {
        setFetchingAuthenticationDocumentList(true);

        AuthenticationService.getAuthenticationDocumentListByStatus(page, limit, status).then((res) => {
            
            if (res.data.success) {
                
                setFetchingAuthenticationDocumentList(false);
                setAuthenticationDocumentList(res.data.data.content);

                if (res.data.data.length === 0) {
                    setPagination(0);
                } else {
                    var last_page = Math.ceil(res.data.data.numberOfElements / limit); 
                    setPagination(last_page);
                }
            }

        }).catch((error) => {
            console.log("getAuthenticationDocumentListByStatus error xxxx", error);

            setFetchingAuthenticationDocumentList(false);
        })
    }


    const getAuthenticationProductList = (page) => {
        setFetchingAuthenticationProductList(true);
        setSearchingProductByType(false);
        setSearchedProductTypeResult([]);

        AuthenticationService.getAuthenticationProductList(page, limit).then((res) => {

            console.log("getAuthenticationProductList res xxxx", res);

            
            if (res.data.success) {
                setAuthenticationProductList(res.data.data.content);

                if (res.data.data.length === 0) {
                    setPagination(0);
                } else {
                    var last_page = Math.ceil(res.data.data.numberOfElements / limit); 
                    setPagination(last_page);
                }

                setFetchingAuthenticationProductList(false);
            }

        }).catch((error) => {
            console.log("getAuthenticationProductList error xxxx", error);

            setFetchingAuthenticationProductList(false);
        })
    }

    const getAuthenticationProductListByProductType = (page, type) => {
        setAuthenticationProductList([]);
        setFetchingAuthenticationProductList(true);
        setSearchingProductByType(true);
  
        AuthenticationService.getAuthenticationProductListByProductType(page, limit, type).then((res) => {

            if (res.data.success) {
                if (res.data.data.length === 0) {
                    setPagination(0);
                } else {
                    var last_page = Math.ceil(res.data.data.numberOfElements / limit); 
                    setPagination(last_page);
                }

                setSearchedProductTypeResult(res.data.data.content);
                setFetchingAuthenticationProductList(false);
            }

        }).catch((error) => {
            console.log("getAuthenticationProductListByProductType error xxxx", error);

            setFetchingAuthenticationProductList(false);
        })
    }

    const getAuthenticationProductListByProductName = (page, name) => {
        setFetchingAuthenticationProductList(true);

        AuthenticationService.getAuthenticationProductListByProductName(page, limit, name).then((res) => {

            if (res.data.success) {
                setFetchingAuthenticationProductList(false);
                setAuthenticationProductList(res.data.data.content);

                if (res.data.data.length === 0) {
                    setPagination(0);
                } else {
                    var last_page = Math.ceil(res.data.data.numberOfElements / limit); 
                    setPagination(last_page);
                }
            }

        }).catch((error) => {
            console.log("getAuthenticationProductListByProductName error xxxx", error);

            setFetchingAuthenticationProductList(false);
        })
    }

    const getAuthenticationProductListByProductReference = (page, reference) => {
        setFetchingAuthenticationProductList(true);

        AuthenticationService.getAuthenticationProductListByProductReference(page, limit, reference).then((res) => {

            if (res.data.success) {
                setFetchingAuthenticationProductList(false);
                setAuthenticationProductList(res.data.data.content);

                if (res.data.data.length === 0) {
                    setPagination(0);
                } else {
                    var last_page = Math.ceil(res.data.data.numberOfElements / limit); 
                    setPagination(last_page);
                }
            }

        }).catch((error) => {
            console.log("getAuthenticationProductListByProductReference error xxxx", error);

            setFetchingAuthenticationProductList(false);
        })
    }
    
    
    const getAuthenticationDateTypeCountFilterByName = (startDate, endDate, name) => {
        setFetchingAuthenticationCount(true);

        AuthenticationService.getAuthenticationDateTypeCountFilterByName(startDate, endDate, name).then((res) => {
            
            console.log("getAuthenticationDateTypeCountFilterByName res aaa", res);

            if (res.data.success) {
                setFetchingAuthenticationCount(false);
                setAuthenticationDateTypeCount(res.data.data);
            }

        }).catch((error) => {
            console.log("getAuthenticationDateTypeCountFilterByName error xxxx", error);

            setFetchingAuthenticationCount(false);
        })
    }

    const getAuthenticationCountFilterByName = (startDate, endDate, name) => {
        setFetchingTotalAuthentication(true);

        AuthenticationService.getAuthenticationCountFilterByName(startDate, endDate, name).then((res) => {
            
            if (res.data.success) {
                setFetchingTotalAuthentication(false);
                setTotalAuthenticationCount(res.data.data);
            }

        }).catch((error) => {
            console.log("getAuthenticationCount error xxxx", error);

            setFetchingTotalAuthentication(false);
        })
    }
    

    const getAuthenticationStatusFilterByName = (startDate, endDate, name) => {
        setFetchingAuthenticationStatus(true);

        AuthenticationService.getAuthenticationStatusFilterByName(startDate, endDate, name).then((res) => {
            
            if (res.data.success) {
                setFetchingAuthenticationStatus(false);
                setTotalAuthenticationStatus(res.data.data);
            }

        }).catch((error) => {
            console.log("getAuthenticationStatus error xxxx", error);

            setFetchingAuthenticationStatus(false);
        })
    }


    const getAuthenticationFailRateFilterByName = (startDate, endDate, name) => {
        setFetchingAuthenticationFailRate(true);

        AuthenticationService.getAuthenticationFailRateFilterByName(startDate, endDate, name).then((res) => {
            
            if (res.data.success) {
                setFetchingAuthenticationFailRate(false);
                setAuthenticationFailRateData(res.data.data);
            }

        }).catch((error) => {
            console.log("getAuthenticationFailRate error xxxx", error);

            setFetchingAuthenticationFailRate(false);
        })
    }

    const getDocumentAuthenticationViewDetails = (document_id) => {
        setViewDocument(true);

        AuthenticationService.getDocumentAuthenticationViewDetails(document_id).then((res) => {
            console.log("getDocumentAuthenticationViewDetails data xxxx", res.data);
            
            if (res.data.success) {
                setViewDocument(false);
                setDocumentViewDetails(res.data.data);
            }

        }).catch((error) => {
            console.log("getDocumentAuthenticationViewDetails error xxxx", error);

            setViewDocument(false);
        })
    }

    const getProductAuthenticationViewDetails = (product_id) => {
        setViewProduct(true);

        AuthenticationService.getProductAuthenticationViewDetails(product_id).then((res) => {
            console.log("getProductAuthenticationViewDetails data xxxx", res.data);
            
            if (res.data.success) {
                setViewProduct(false);
                setProductViewDetails(res.data.data);
            }

        }).catch((error) => {
            console.log("getProductAuthenticationViewDetails error xxxx", error);

            setViewProduct(false);
        })
    }

    const getProductAuthenticationLogs = (parameters) => {
        setFetchingAuthenticationProductList(true);

        AuthenticationService.getProductAuthenticationLogs(parameters).then((res) => {
            console.log("getProductAuthenticationLogs data xxxx", res);

            if (res.data.success) {
                setAuthenticationProductList(res.data.data.content);

                if (res.data.data.length === 0) {
                    setPagination(0);
                } else {
                    var last_page = Math.ceil(res.data.data.numberOfElements / limit); 
                    setPagination(last_page);
                }

                setFetchingAuthenticationProductList(false);
            }

        }).catch((error) => {
            console.log("getProductAuthenticationLogs error xxxx", error);

            setFetchingAuthenticationProductList(false);
        })
    }

    const getDocumentAuthenticationLogs = (parameters) => {
        setFetchingAuthenticationDocumentList(true);

        AuthenticationService.getDocumentAuthenticationLogs(parameters).then((res) => {
            console.log("getDocumentAuthenticationLogs data xxxx", res);

            if (res.data.success) {
                setAuthenticationDocumentList(res.data.data.content);

                if (res.data.data.length === 0) {
                    setPagination(0);
                } else {
                    var last_page = Math.ceil(res.data.data.numberOfElements / limit); 
                    setPagination(last_page);
                }

                setFetchingAuthenticationDocumentList(false);
            }

        }).catch((error) => {
            console.log("getDocumentAuthenticationLogs error xxxx", error);

            setFetchingAuthenticationDocumentList(false);
        })
    }


    return {isFetchingTotalAuthentication, totalAuthenticationCount, getAuthenticationCount, isFetchingAuthenticationStatus, 
        getAuthenticationStatus, totalAuthenticationStatus, isFetchingAuthenticationFailRate, getAuthenticationFailRate,
        authenticationFailRateData, getAuthenticationDateTypeCount, authenticationDateTypeCount,
        getAuthenticationDocumentList, pagination, authenticationDocumentList, getAuthenticationProductList, authenticationProductList,
        isFetchingAuthenticationDocumentList, isFetchingAuthenticationProductList, isFetchingAuthenticationCount, 
        getAuthenticationDateTypeCountFilterByName, getAuthenticationCountFilterByName, getAuthenticationStatusFilterByName, 
        getAuthenticationFailRateFilterByName, getAuthenticationDocumentListByType, getAuthenticationDocumentListByStatus,
        getAuthenticationProductListByProductName, getAuthenticationProductListByProductType, getAuthenticationProductListByProductReference,
        isViewDocument, isViewProduct, documentViewDetails, productViewDetails, getDocumentAuthenticationViewDetails, getProductAuthenticationViewDetails,
        isSearchingProductByType, searchedProductTypeResult, getProductAuthenticationLogs, getDocumentAuthenticationLogs,
        
        
        
    }
}

export default useAuthentication